import './App.css';
import { BrowserRouter } from 'react-router-dom';
import { AppRouter } from './Router';
import { Provider } from 'react-redux';
import { store } from './redux/store';

function App() {
  return (
      <Provider store={store}>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
      </Provider>
  );
}

export default App;
